export default "__VITE_ASSET__XSsgZNsV__"